import React from "react";
import { FormattedMessage } from 'react-intl';

import Constants from '../../../definitions/constants';
import FormatTooling from '../../../tooling/formatTooling';
import InterfaceTooling from '../../../tooling/interfaceTooling';
import { intl } from '../../../locales/localesConfig';
import LocaleTooling from "../../../tooling/localeTooling";

import Spinner from '../common/interface/spinner';

const CalculationsSummaryTable = props => {
  const {
    data,
    loading
  } = props;
  
  return (
    <div className={"table_component entity_table_component calculations_summary_table"}>
      <div className="table_component_table_wrapper">
        <div className="table_component_table_header_wrapper">
          <table>
            <thead>
              <tr>
                <th className={"model_column"}>
                  <div title={intl.formatMessage({ id: "biCalculationsSummary.columns.model"})}>{intl.formatMessage({ id: "biCalculationsSummary.columns.model"})}</div>
                </th>
                <th className={"period_column"}>
                  <div title={intl.formatMessage({ id: "biCalculationsSummary.columns.period"})}>{intl.formatMessage({ id: "biCalculationsSummary.columns.period"})}</div>
                </th>
                <th className={"total_column"}>
                  <div title={intl.formatMessage({ id: "biCalculationsSummary.columns.total"})}>{intl.formatMessage({ id: "biCalculationsSummary.columns.total"})}</div>
                </th>
                <th className={"count_column"}>
                  <div title={LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "biCalculationsSummary.columns.count"}))}>{LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "biCalculationsSummary.columns.count"}))}</div>
                </th>
              </tr>
            </thead>
          </table>
        </div>
        <div className="table_component_table_body_wrapper">
          <table>
            <thead>
              <tr>
                <th className={"model_column"}>
                  <div>{""}</div>
                </th>
                <th className={"period_column"}>
                  <div>{""}</div>
                </th>
                <th className={"total_column"}>
                  <div>{""}</div>
                </th>
                <th className={"count_column"}>
                  <div>{""}</div>
                </th>
              </tr>
            </thead>
            <tbody>
            {data && Object.keys(data).map((key,i) => {
              let periods_data = data[key];
              return periods_data.map((period_data, j) => {
                return (
                  <tr key={i + "_" + j} className={(j==periods_data.length-1) ? "last_period_row" : ""}>
                    {(j==0) && (
                      <td className={"model_column" + ((i==Object.keys(data).length-1) ? " last_model_row" : "")} rowSpan={periods_data.length}>
                        <div title={key}>{key}</div>
                      </td>
                    )}
                    <td className="period_column">
                      <div title={period_data["period_name"]}>{period_data["period_name"]}</div>
                    </td>
                    <td className="total_column">
                      <div title={period_data["total"]}>{"$" + FormatTooling.defaultsTextFormatTypes(period_data["total"],Constants.crudGenerator.dataTypes.NUMBER)}</div>
                    </td>
                    <td className="count_column">
                      <div title={period_data["count"]}>{FormatTooling.defaultsTextFormatTypes(period_data["count"],Constants.crudGenerator.dataTypes.NUMBER)}</div>
                    </td>
                  </tr>                      
                ); 
              });    
            })}
            </tbody>
          </table>
          {loading && (<div className="table_eof">
            <Spinner/>
            <span>
              <FormattedMessage id="biCalculationsSummary.loadingCalculationsSummary"/>
            </span>
          </div>)}
        </div>
      </div>
    </div>
  );
}

export default CalculationsSummaryTable;



// WEBPACK FOOTER //
// ./source/client/components/biCalculationsSummary/calculationsSummaryTable.jsx